import { ReactNode } from "react";
import { Colors, tailwindVars } from "../../../utils/tailwind.util";

type Props = {
  isDot?: boolean;
  className?: string;
  color: Colors;
  children: ReactNode;
};

export const Badge = ({ children, isDot, color, className }: Props) => {
  return (
    <div className={`py-1 px-2  text-xs   font-medium  ${tailwindVars.getBgColor200(color)} ${className}`}>
      {isDot && <span className={` size-[7px] me-1 rounded-full  ${tailwindVars.getBgColor400(color)}`}></span>}
      <span className={`   ${tailwindVars.getTextColor800(color)}`}>{children}</span>
    </div>
  );
};
